module.exports = __webpack_public_path__ + "img/flow_icon_image@2x.461340b2.png";